export const formatCountForCta = (count: number): string => {
  if (typeof count === 'number' && !Number.isNaN(count) && count >= 0) {
    return count >= 100 ? '100+' : `${count}`;
  }
  return '0';
};
